import React, { useContext } from 'react';
import { ReadMoreButton } from 'src/components/shared/elements/buttons/ReadMoreButton';
import { ProductCard } from 'src/components/shared/products/ProductCard';
import type { Product } from 'src/models/product/schema';
import { I18nContext } from 'src/stores/I18n';
import { mixpanel } from 'src/utils/mixpanel';
import styles from './index.module.scss';

export const CategoryProducts: React.FC<{
  products: Product[];
  moreButtonPath?: string;
  targetAttributionToken?: string;
}> = ({ products, moreButtonPath, targetAttributionToken }) => {
  const localeResources = useContext(I18nContext);
  const handleClick = (product: Product) => {
    mixpanel.track('ProductDetailLinkClicked', {
      largeCategoryId: product.largeCategoryId,
      middleCategoryId: product.middleCategoryId,
      smallCategoryId: product.smallCategoryId,
      brandId: product.brandId,
      productId: product.productId
    });
  };
  return (
    <>
      <div className={styles.container}>
        {products.map((product) => (
          <div key={product.productId} onClick={() => handleClick(product)}>
            <ProductCard
              product={product}
              section="category_products"
              targetAttributionToken={targetAttributionToken}
            />
          </div>
        ))}
      </div>
      {moreButtonPath && products.length === 8 && (
        <div className={styles.moreButton}>
          <ReadMoreButton text={localeResources.commons.showMore} href={moreButtonPath} />
        </div>
      )}
    </>
  );
};
